import { match } from 'ts-pattern';
import { Model } from '../index.js';
export const migrateToV9 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().when((e)=>Model.FullDoorBase.isId(e.id), (e)=>({
                ...e,
                applianceId: null
            })).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v09.js.map